import { LegalPage } from "@/pages/PrivacyPolicy";

const SECTIONS = [
  ["Use of this website", [
    "This website is provided for general information about Be Green Group and its commercial PPA offering.",
    "By using the site you agree to use it only for lawful purposes and in a way that does not restrict or inhibit anyone else's use.",
  ]],
  ["Content and accuracy", [
    "Information on this site is general and indicative only.",
    "Any figures, potential savings or system suitability information are subject to detailed site inspection, engineering review, network approval, credit approval and final contract terms.",
  ]],
  ["No offer or guarantee", [
    "Content on this site does not constitute a binding offer or an agreement.",
    "A commercial PPA is only entered into via a formal signed Power Purchase Agreement.",
  ]],
  ["Third-party links", [
    "This site may include links to third-party websites. Be Green Group does not endorse and is not responsible for those sites.",
  ]],
  ["Intellectual property", [
    "The Be Green Group name, logo and site content are the property of Be Green Group.",
  ]],
  ["Limitation of liability", [
    "To the extent permitted by law, Be Green Group is not liable for any loss arising from use of, or reliance on, information on this website.",
  ]],
];

export default function Terms() {
  return (
    <LegalPage
      title="Website Terms of Use"
      testId="terms-page"
      sections={SECTIONS}
      placeholderNote
      intro="Please read these terms carefully before using begreengroup.com.au."
    />
  );
}
